(function () {
  'use strict';

  angular.module('dashboard.interval', ['ngResource']);
})();
